import type { Status } from '@xleddyl/types'
import { createApp } from 'vue'
import Alert from '~/components/core/Alert.vue'

export type AlertProps = {
   title: string
   description?: string
   type: 'confirm' | 'loading'
   status?: Status
   confirmLabel?: string
   discardLabel?: string
}

let currentAlert: ReturnType<typeof createApp> | null = null
let currentAlertDiv: HTMLDivElement | null = null

const teardown = () => {
   if (currentAlert) {
      currentAlert.unmount()
      currentAlert = null
   }
   if (currentAlertDiv) {
      document.body.removeChild(currentAlertDiv)
      currentAlertDiv = null
   }
}

export default defineNuxtPlugin(() => {
   return {
      provide: {
         alert: {
            show: (props: AlertProps): Promise<boolean> => {
               return new Promise((resolve) => {
                  teardown()

                  const alertDiv = document.createElement('div')
                  document.body.appendChild(alertDiv)
                  currentAlertDiv = alertDiv

                  currentAlert = createApp(Alert, {
                     ...props,
                     visible: true,
                     onConfirm: () => {
                        resolve(true)
                        teardown()
                     },
                     onCancel: () => {
                        resolve(false)
                        teardown()
                     },
                  })

                  currentAlert.mount(alertDiv)
               })
            },
            hide: () => {
               teardown()
            },
         },
      },
   }
})
